import { graphql } from "react-relay";

export const UpsertReportGroupsMutation = graphql`
  mutation UpsertReportGroupsMutation(
    $connections: [ID!]!
    $input: UpsertReportGroupsInput
  ) {
    upsertReportGroups(input: $input) {
      reportGroups
        @appendNode(
          connections: $connections
          edgeTypeName: "ReportGroupEdge"
        ) {
        deliverySettings {
          ... on EmailSettings {
            firstMatchOnly
            recipients {
              account_owner
              event_owner
              resource_owner
              value
            }
            subject
            template
            type
          }
          ... on SlackSettings {
            firstMatchOnly
            recipients {
              account_owner
              event_owner
              resource_owner
              value
            }
            template
            type
            type
          }
          ... on JiraSettings {
            description
            firstMatchOnly
            project
            recipients {
              account_owner
              event_owner
              resource_owner
              tag
              value
            }
            summary
            template
            type
          }
          ... on ServiceNowSettings {
            firstMatchOnly
            impact
            recipients {
              account_owner
              event_owner
              resource_owner
              tag
              value
            }
            shortDescription
            template
            type
            urgency
          }
          ... on MSTeamsSettings {
            firstMatchOnly
            recipients {
              account_owner
              event_owner
              resource_owner
              tag
              value
            }
            template
            type
          }
        }
        enabled
        groupBy
        id
        name
        schedule
      }
    }
  }
`;
